const generateHumanDate = (dateString) => {
	// return time ago format for the date string from the date created.
	//  use the shopify.locale to determine the language of the time ago string.
	const date = new Date(dateString);
	const now = new Date();
	const diffInSeconds = Math.floor((now - date) / 1000);

	const intervals = {
		year: 31536000,
		month: 2592000,
		week: 604800,
		day: 86400,
		hour: 3600,
		minute: 60,
		second: 1,
	};

	for (const [unit, secondsInUnit] of Object.entries(intervals)) {
		const interval = Math.floor(diffInSeconds / secondsInUnit);
		if (interval >= 1) {
			return new Intl.RelativeTimeFormat(Shopify.locale || 'de', { numeric: 'auto' }).format(-interval, unit);
		}
	}
	return new Intl.RelativeTimeFormat(Shopify.locale || 'de', { numeric: 'auto' }).format(0, 'second');
};
class ReviewRowItem extends HTMLElement {
	render({
		id = '',
		rating = 0,
		title = '',
		comments = '',
		author = {},
		attributes = [],
		photos = [],
		time_ago = '',
		date_created = '',
		verified = false,
	}) {
		this.classList.add('review-row-item');
		this.setAttribute('review-id', id);
		const s = window.themeVariables.strings.reviewsIo;
		const verifiedHtml = verified
			? `<div class="review-row-item__verified">${window.themeVariables.icons.verified}<span>${s.verifiedCustomer}</span>
					<button type="button" class="review-row-item__verified-info" aria-controls="verified-review-info-modal" aria-label="${s.verifiedInfoLabel}">
						<svg aria-hidden="true" width="20" height="20" viewBox="0.5 0.5 23 23" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="10"/>
							<g fill="currentColor" stroke="none" transform="matrix(0.025 0 0 0.025 0 24)">
								<path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Z"/>
							</g>
						</svg>
					</button>
				</div>`
			: '';
		const timeAgoText = generateHumanDate(date_created);
		const authorAttrs = (author.attributes || [])
			.map(
				(attr) => `
			<div class="review-row-item__author-attr">
				<span class="review-row-item__author-attr-label">${attr.label}</span>
				<span class="review-row-item__author-attr-value">${attr.value}</span>
			</div>`,
			)
			.join('');

		const productAttrs = attributes
			.map((attr) => {
				const percent = ((parseFloat(attr.value) - 1) / 4) * 100;
				const optionsHtml = attr.options.map((o) => `<span>${o}</span>`).join('');
				return `
			<div class="review-row-item__attr">
				<p class="review-row-item__attr-label">${attr.label}</p>
				<div class="review-row-item__attr-track">
					<div class="review-row-item__attr-thumb" style="left:${percent}%"></div>
				</div>
				<div class="review-row-item__attr-options">${optionsHtml}</div>
			</div>`;
			})
			.join('');

		const photosHtml = photos.filter((src) => !!src).length
			? `<div class="review-row-item__photos">${photos
					.filter((src) => !!src)
					.map((src) => `<img loading="lazy" src="${src}" alt="Review photo">`)
					.join('')}</div>`
			: '';

		this.innerHTML = `
			<div class="review-row-item__left">
				${verifiedHtml}
				<p class="review-row-item__author">${author.name || ''}</p>
				<div class="review-row-item__author-attrs">${authorAttrs}</div>
			</div>
			<div class="review-row-item__right">
				<rating-stars class="review-row-item__stars" rating="${rating}"></rating-stars>
				<p class="review-row-item__title">${title}</p>
				<p class="review-row-item__comments">${comments}</p>
				<div class="review-row-item__attrs">${productAttrs}</div>
				${photosHtml}
				<div class="review-row-item__footer" >
					<span class="review-row-item__helpful" hidden>${s.helpful} <a href="#">${s.yes}</a></span>
					<span class="review-row-item__time">${timeAgoText}</span>
				</div>
			</div>`;
	}
}
if (!customElements.get('review-row-item')) {
	customElements.define('review-row-item', ReviewRowItem);
}
